export default import.meta.ROLLUP_FILE_URL_$Lfv1Grl;